export default "__VITE_ASSET__DvvVvasn__"